import classNames from 'classnames';
import { ComponentSizes, ThemeColors } from 'models/general';
import React, { CSSProperties } from 'react';
import { Link } from 'react-router-dom';
import { MButtonThemes } from './MButton.model';
import classes from './MButton.module.scss';

type Props = {
  theme?: MButtonThemes;
  className?: string;
  contentClassName?: string;
  color?: ThemeColors;
  disabled?: boolean;
  type?: 'submit' | 'reset' | 'button';
  block?: boolean;
  to?: string;
  style?: CSSProperties;
  size?: ComponentSizes;
  tabIndex?: number;
  isLoading?: boolean;
  percentage?: number;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onBlur?: (event?: React.FocusEvent<HTMLButtonElement>) => void;
  onFocus?: () => void;
};

const MButtonView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const spinner =
    props.isLoading && typeof props.percentage !== 'undefined' ? (
      <React.Fragment>
        <span className={classes['progress-text']}>{`${props.percentage}%`}</span>
        <div className={classNames(classes['bar'], classes['top'], classes['delayTop'])}></div>
        <div className={classNames(classes['bar'], classes['bar--side'], classes['right'], classes['delayRight'])}></div>
        <div className={classNames(classes['bar'], classes['bottom'], classes['delayBottom'])}></div>
        <div className={classNames(classes['bar'], classes['bar--side'], classes['left'], classes['delayLeft'])}></div>
      </React.Fragment>
    ) : null;

  return props.to ? (
    <Link className={classes['link']} to={props.to} onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave}>
      <button
        tabIndex={props.tabIndex}
        style={props.style}
        className={classNames(
          classes['btn'],
          classes[`btn--size-${props.size}`],
          classes[`btn--${props.color}`],
          classes[`btn--${props.color}--${props.theme}`],
          {
            [classes['btn--disabled']]: props.disabled,
            [classes['btn--block']]: props.block,
            [classes['btn--loading']]: props.isLoading,
            [classes[`btn--loading--size-${props.size}`]]: props.percentage !== undefined && props.isLoading,
          },
          props.className,
        )}
        type={props.type}
        onClick={props.onClick}
        disabled={props.disabled || props.isLoading}
        onBlur={props.onBlur}
        onFocus={props.onFocus}
      >
        {spinner}
        <span className={classes['btnContent']}>{props.children}</span>
      </button>
    </Link>
  ) : (
    <button
      tabIndex={props.tabIndex}
      style={props.style}
      className={classNames(
        classes['btn'],
        props.className,
        classes[`btn--size-${props.size}`],
        classes[`btn--${props.color}`],
        classes[`btn--${props.color}--${props.theme}`],
        {
          [classes['btn--disabled']]: props.disabled,
          [classes['btn--block']]: props.block,
          [classes['btn--loading']]: props.isLoading,
          [classes['btn--loading--btnContent']]: props.isLoading,
        },
      )}
      type={props.type}
      onClick={props.onClick}
      disabled={props.disabled || props.isLoading}
      onBlur={props.onBlur}
      onFocus={props.onFocus}
    >
      {spinner}
      <span className={`${classes['btnContent']} ${props.contentClassName}`}>{props.children}</span>
    </button>
  );
};

MButtonView.displayName = 'MButtonView';
MButtonView.defaultProps = {};

export default MButtonView;
